export const PRINTFUL_INFO_IDS = {
    PRINTFUL_CATEGORIES: "printful-categories",
    PRINTFUL_PRODUCT_TYPES: "printful-product-types",
    PRINTFUL_PRODUCTS: "printful-products",
    PRINTFUL_PRODUCT_VARIANTS: "printful-product-variants",
    PRINTFUL_STORES: "printful-stores",
    PRINTFUL_PRODUCTS_PRICE: "printful-products-price",
    PRINTFUL_SYNC_PRODUCTS: "printful-sync-products",
    PRINTFUL_SYNC_PRODUCTS_PRICE: "printful-sync-products-price",
    PRINTFUL_SYNC_PRODUCTS_VARIANTS: "printful-sync-products-variants",
    PRINTFUL_SYNCS: "printful-syncs",
    PRINTFUL_SYNC_PRODUCTS_SYNC: "printful-sync-products-sync",
    PRINTFUL_PRODUCTS_SYNC: "printful-products-sync",
};
